// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");

function setNestedString(root, segments, value) {
  var lastIndex = segments.length - 1 | 0;
  var walk = function (obj, index) {
    var key = Belt_Array.getExn(segments, index);
    if (index === lastIndex) {
      obj[key] = value;
      return ;
    }
    var existing = Belt_Option.flatMap(Js_dict.get(obj, key), Js_json.decodeObject);
    var next = existing !== undefined ? existing : ({});
    walk(next, index + 1 | 0);
    obj[key] = next;
  };
  walk(root, 0);
}

function defaultInputValues(param) {
  var dict = {};
  dict["customer_details_data.source_type"] = "FeedFile";
  dict["customer_details_data.email"] = "user@example.com";
  dict["more_details.status"] = "Closed";
  return dict;
}

function getInputValue(inputs, path) {
  return Belt_Option.getWithDefault(Js_dict.get(inputs, path), "");
}

function mergeInputsForPaths(paths, current) {
  var defaults = defaultInputValues();
  var merged = {};
  Belt_List.forEach(paths, (function (path) {
          var v = Js_dict.get(current, path);
          var value;
          if (v !== undefined) {
            value = v;
          } else {
            var v$1 = Js_dict.get(defaults, path);
            value = v$1 !== undefined ? v$1 : "";
          }
          merged[path] = value;
        }));
  return merged;
}

function buildFixtureJson(inputs) {
  var payloadRoot = {};
  var contextRoot = {};
  Belt_Array.forEach(Js_dict.entries(inputs), (function (param) {
          var value = param[1];
          var path = param[0];
          var segments = Js_string.split(".", path);
          if (segments.length < 2) {
            return ;
          }
          if (!Js_string.startsWith("context.", path)) {
            if (Js_string.startsWith("customer_details_data.", path) || Js_string.startsWith("more_details.", path)) {
              return setNestedString(payloadRoot, segments, value);
            } else {
              return ;
            }
          }
          var contextSegments = Belt_Array.sliceToEnd(segments, 1).slice(0);
          setNestedString(contextRoot, contextSegments, value);
        }));
  var payload = {};
  var v = Js_dict.get(payloadRoot, "customer_details_data");
  if (v !== undefined) {
    payload["customer_details_data"] = v;
  } else {
    payload["customer_details_data"] = {};
  }
  var v$1 = Js_dict.get(payloadRoot, "more_details");
  if (v$1 !== undefined) {
    payload["more_details"] = v$1;
  } else {
    payload["more_details"] = {};
  }
  return [
          payload,
          contextRoot
        ];
}

var payloadJsonFromInputs = buildFixtureJson;

function cloneInputs(inputs) {
  var copy = {};
  Belt_Array.forEach(Js_dict.entries(inputs), (function (param) {
          copy[param[0]] = param[1];
        }));
  return copy;
}

exports.setNestedString = setNestedString;
exports.defaultInputValues = defaultInputValues;
exports.getInputValue = getInputValue;
exports.mergeInputsForPaths = mergeInputsForPaths;
exports.buildFixtureJson = buildFixtureJson;
exports.payloadJsonFromInputs = payloadJsonFromInputs;
exports.cloneInputs = cloneInputs;
/* No side effect */
